import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { RootState } from 'reducers';
import { Constants, Globals } from 'utils';
import { ChatService, HomeService } from 'services';
import { Calendar, ContactCallIcon, ContactMessageIcon, ContactVideoCallIcon } from 'assets/icons';
import { DatePicker, FallbackImage } from 'components';
import { WhiteImage } from 'assets/img';
import VideoRoom from './video/video-room';

const MODAL = {
  NONE: 0,
  VIDEO_ROOM: 1,
};

const Requests = () => {
  const { canResetFilters, data, filters, modal, onAccept, onCall, onChangeFilters, onChat, onFinish, onReject, onResetFilters, onVideoCall, selectedItem, setModal, videoRoomToken } = useForm();

  return (
    <main id="requests">

      {(modal === MODAL.VIDEO_ROOM && videoRoomToken && selectedItem.video_room_url) && (
        <VideoRoom
          origin="advertisement"
          consultation={selectedItem}
          token={videoRoomToken}
          onFinish={onFinish}
          onClose={() => setModal(MODAL.NONE)}
        />
      )}

      <div className="filters">
        <DatePicker
          placeholder="Desde"
          value={filters.since}
          onChange={(v: string) => onChangeFilters(v, 'since')}
          showYearDropdown
        />
        <DatePicker
          placeholder="Hasta"
          value={filters.until}
          onChange={(v: string) => onChangeFilters(v, 'until')}
          showYearDropdown
        />

        {canResetFilters && (
          <button onClick={onResetFilters}>Limpiar</button>
        )}
      </div>

      <section className="requests-registry">
        <div className="requests-registry__header">
          <h2 className="requests-registry__title">Registro</h2>
        </div>

        <div className="registry-list">
          {data.map((item: any, index: number) => (

            <ItemCard
              key={index}
              item={item}
              onAccept={onAccept}
              onReject={onReject}
              onFinish={onFinish}
              onCall={onCall}
              onChat={onChat}
              onVideoCall={onVideoCall}
            />
          ))}

          {(!data.length) && (
            <p className="empty">No hay registros</p>
          )}
        </div>
      </section>
    </main>
  )
}

const ItemCard = ({ item, onAccept, onReject, onFinish, onCall, onChat, onVideoCall }: any) => {
  const { adDescription, adTitle, banner, date, isBanner, isCompleted, method } = useMemo(() => {
    const isBanner = item.advertisement?.type === 2;
    const isCompleted = item.status === 3;
    const adDetails = item.advertisement?.details?.at(0) || {};
    const adTitle = adDetails?.title || 'Anuncio Clasificado';
    const adDescription = adDetails?.content || 'El usuario ha solicitado información sobre su publicación.';

    let banner = {
      label: '',
      icon: adDetails?.image
        ? Globals.fromPhotos(adDetails?.image)
        : WhiteImage,
    };
    let method = null;
    const date = moment(item.created_at).format('DD-MM-YYYY');

    switch (item.advertisement?.advertising_rate_id) {
      case 1: banner.label = 'Pop-UP'; break;
      case 2: banner.label = 'Banner Principal'; break;
      case 3: banner.label = 'Banner principal categorías'; break;
      case 4: banner.label = 'Banner lista de categoría'; break;
      default: banner.label = 'Banner Publicitario'; break;
    }

    switch (item.contact_method) {
      case 1: method = { label: 'Videollamada', icon: ContactVideoCallIcon }; break;
      case 2: method = { label: 'Llamada', icon: ContactCallIcon }; break;
      case 3: method = { label: 'Chat', icon: ContactMessageIcon }; break;
      default: method = { label: 'Contacto', icon: WhiteImage }; break;
    }

    return {
      adDescription,
      adTitle,
      banner,
      date,
      isBanner,
      isCompleted,
      method,
    }
  }, [item]);

  return (
    <article className="registry-item">
      <div className="registry-item__user">
        <FallbackImage
          src={item.user?.photo}
          placeholder={WhiteImage}
          className="avatar"
          placeholderClassName="avatar"
          alt={item.user?.name}
        />
        <div className="user-info">
          <span className="user-name">{item.user?.name}</span>
          <span className="status-badge" data-status={String(item.status)}>{item.status_txt}</span>
        </div>
      </div>

      <div className="registry-item__type">
        <span className="label">Solicitud</span>
        <div className="icon-text">
          <img className="contact-icon" src={method.icon} alt={method.label} />
          <span>{method.label}</span>
        </div>
      </div>

      {isBanner ? (
        <>
          <div className="detail-block" />
          <div className="banner-preview">
            <img
              src={banner.icon}
              alt={banner.label}
              style={{
                width: '100%',
                maxWidth: '60px',
                height: 'auto',
                objectFit: 'contain',
                borderRadius: '8px'
              }}
            />
            <span style={{ display: 'block', marginTop: '10px' }}>{banner.label}</span>
          </div>
        </>
      ) : (
        <>
          <div className="detail-block">
            <span className="label">Título</span>
            <p className="title-text">{adTitle}</p>
          </div>
          <div className="detail-block">
            <p className="description-text">{adDescription}</p>
          </div>
        </>
      )}

      <div className="registry-item__meta">
        <span className="date"><img src={Calendar} alt="Calendario" /> {date}</span>
        {item.status === 0 && ((
          <div className="actions">
            <button className="btn btn--reject" onClick={() => onReject(item)}>RECHAZAR</button>
            <button className="btn btn--accept" onClick={() => onAccept(item)}>ACEPTAR</button>
          </div>
        ))}
        {(item.status === 1 || item.status === 3) && ((
          <>
            {item.status === 1 && (
              <div className="actions">
                <button className="btn btn--finish" onClick={() => onFinish(item)}>CULMINAR</button>
              </div>
            )}
            <div className="actions">
              {item.contact_method === 1 && (
                <button
                  className="call-to-action"
                  disabled={isCompleted}
                  onClick={() => !isCompleted && onVideoCall(item)}
                >
                  <img src={method.icon} title="Videollamada" alt="Videollamada" />
                </button>
              )}

              {item.contact_method === 2 && (
                <button
                  className="call-to-action"
                  disabled={isCompleted}
                  onClick={() => !isCompleted && onCall(item)}
                >
                  <img src={method.icon} title="Llamada" alt="Llamada" />
                </button>
              )}

              {item.contact_method === 3 && (
                <button
                  className="call-to-action"
                  disabled={isCompleted}
                  onClick={() => !isCompleted && onChat(item)}
                >
                  <img src={method.icon} title="Chat" alt="Chat" />
                </button>
              )}
            </div>
          </>
        ))}
      </div>
    </article>
  );
}

const useForm = () => {
  const INITIAL_FILTERS = {
    type: 1,
    since: '',
    until: '',
  };

  const nav = useHistory();
  const user = useSelector((state: RootState) => state.user);
  const [modal, setModal] = useState(MODAL.NONE);
  const [data, setData] = useState<any[]>([]);
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [videoRoomToken, setVideoRoomToken] = useState<string>();
  const [selectedItem, setSelectedItem] = useState({
    id: 0,
    video_room_url: '',
    client_id: '',
    affiliate_id: 0,
  });

  const getData = async () => {
    try {
      const _filters = await Globals.getUpdatedState(setFilters);
      const payload = {
        ..._filters,
        user_id: user?.id,
      }
      const response: any = await HomeService.affiliate.getContactRequests(payload);
      console.log("Respuesta de solicitudes de contacto:", response);
      if (response?.result && response?.data) {
        const sortedData = response.data.sort((a: any, b: any) => {
          const getWeight = (status: number) => {
            if (status === 0 || status === 1) return 1;
            if (status === 3) return 2;
            if (status === 2) return 3;
            return 4;
          };

          const weightA = getWeight(a.status);
          const weightB = getWeight(b.status);

          if (weightA === weightB) {
            return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
          }

          return weightA - weightB;
        });
        setData(sortedData);
      }

    } catch (error) {
      console.log(error);
    }
  }

  const getVideoRoomToken = async () => {
    try {
      const accessRes: any = await HomeService.affiliate.getVideoRoomAccess();
      if (accessRes?.token) {
        const decoded = atob(accessRes.token);
        setVideoRoomToken(decoded);
        return decoded;
      }
      return null;

    } catch (error) {
      console.log(error);
    }
  }

  const onChangeFilters = <T extends keyof typeof filters>(value: any, target: T) => {
    setFilters(s => ({ ...s, [target]: value }));
    getData();
  }

  const onResetFilters = () => {
    setFilters(INITIAL_FILTERS);
    getData();
  }

  const onAccept = async (item: any) => {
    Globals.confirm(
      '¿Estás seguro de que deseas aceptar esta solicitud?',
      async () => {
        try {
          const response: any = await HomeService.affiliate.setContactStatus({ id: item.id, status: 1 });

          if (item.contact_method === 1 && response?.videoData) {
            if (!videoRoomToken) await getVideoRoomToken();
            setSelectedItem({
              id: item.id,
              video_room_url: response.videoData.video_room_url,
              client_id: response.videoData.client_id,
              affiliate_id: response.videoData.affiliate_id,
            });
          }
          Globals.showSuccess('Solicitud aceptada exitosamente');
          getData();

        } catch (error) {
          console.error('Error al aceptar la solicitud:', error);
        }
      }
    );
  }
  const onReject = (item: any) => {
    Globals.confirm(
      '¿Estás seguro de que deseas rechazar esta solicitud?',
      async () => {
        try {
          await HomeService.affiliate.setContactStatus({ id: item.id, status: 2 });
          Globals.showSuccess('Solicitud rechazada exitosamente');
          getData();

        } catch (error) {
          console.error('Error al rechazar la solicitud:', error);
        }
      }
    );
  }

  const onFinish = (item: any) => {
    Globals.confirm(
      '¿Deseas dar por culminado el contacto con este cliente?',
      async () => {
        try {
          await HomeService.affiliate.setContactStatus({ id: item.id, status: 3 });
          Globals.showSuccess('Solicitud culminada exitosamente');
          getData();

        } catch (error) {
          console.error('Error al culminar la solicitud:', error);
        }
      }
    );
  }

  const onCall = async (item: any) => {
    try {
      const phoneCode = item.user?.phonecode?.name || '';
      const phoneNumber = item.user?.phone || '';
      const fullPhone = `${phoneCode}${phoneNumber}`;

      if (fullPhone) {
        await window.open(`tel:${fullPhone}`, '_blank');
      } else {
        Globals.showError('No se encontró un número de teléfono para este usuario.');
      }
    } catch (error) {
      console.log('Error en onCall:', error);
    }
  }

  const onChat = async (item: any) => {
    try {
      const chat: any = await ChatService.admin.create({ _user_id: item.user_id, doctor_id: user?.id });
      let env = '';
      if (user.affiliate_type === Constants.AFFILIATE_TYPES.MEDIC) {
        env = 'doctor';
      } else if (user.affiliate_type === Constants.AFFILIATE_TYPES.CLINIC) {
        env = 'clinic';
      } else {
        env = 'business';
      }
      nav.push(`/${env}/chat?chat_id=${btoa(`${chat?.id}&${moment().format('YYYYMMDD')}`)}`);

    } catch (error) {
      console.log("Error en onChat:", error);
    }
  }

  const onVideoCall = async (item: any) => {
    try {
      if (item.video_room_url) {
        if (!videoRoomToken) await getVideoRoomToken();
        setSelectedItem({
          id: item.id,
          video_room_url: item.video_room_url,
          client_id: item.client_id,
          affiliate_id: item.affiliate_id,
        });
        setModal(MODAL.VIDEO_ROOM);

      } else {
        Globals.showError('No se encontró la sala de la videollamada.');
      }
    } catch (error) {
      console.log('Error en onCall:', error);
      setModal(MODAL.NONE);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const canResetFilters = useMemo(() => {
    return JSON.stringify(filters) !== JSON.stringify(INITIAL_FILTERS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return {
    canResetFilters,
    data,
    filters,
    modal,
    onAccept,
    onCall,
    onChangeFilters,
    onChat,
    onFinish,
    onReject,
    onResetFilters,
    onVideoCall,
    selectedItem,
    setModal,
    videoRoomToken,
  }
}

export default Requests